var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserOutButtonUnconfirmed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9332 11.5333C13.7332 11.5333 15.1332 10.0666 15.1332 8.26665C15.1332 6.46665 13.6665 5.06665 11.8665 5.06665C10.0665 5.06665 8.6665 6.53332 8.6665 8.26665C8.6665 10.0666 10.1332 11.5333 11.9332 11.5333ZM11.8665 6.39998C11.9332 6.39998 11.9332 6.39998 11.8665 6.39998C12.9332 6.39998 13.7998 7.26665 13.7998 8.33332C13.7998 9.39998 12.9332 10.2 11.8665 10.2C10.7998 10.2 9.99984 9.33332 9.99984 8.33332C9.99984 7.26665 10.8665 6.39998 11.8665 6.39998V6.39998Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3998 15.1333L17.2665 14.9333C15.9332 13.4667 14.0665 12.6 12.0665 12.6667C10.0665 12.6 8.13317 13.4667 6.79984 14.9333L6.6665 15.1333V20.2C6.6665 20.8 7.13317 21.3333 7.79984 21.3333H16.3332C16.9332 21.3333 17.4665 20.8 17.4665 20.2V15.1333H17.3998ZM16.0665 20H7.99984V15.6C9.0665 14.5333 10.5332 14 12.0665 14C13.5332 13.9333 14.9998 14.5333 16.0665 15.6V20Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutButtonUnconfirmed);
export default __webpack_public_path__ + "static/media/user-out-button_unconfirmed.d0834fd19c5647e00c9db412e0c1bbd4.svg";
export { ForwardRef as ReactComponent };